import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { GitStatus } from '@common/git/types/git-status.type';

@Component({
  selector: 'mc-workspace-file-git-status',
  templateUrl: './workspace-file-git-status.component.html',
  styleUrls: ['./workspace-file-git-status.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkspaceFileGitStatusComponent {
  @Input() status: GitStatus;
}
